const LABELS: Record<string, string> = {
  Volume: 'Volume',
  Price: 'Price',
  BaisseClause: 'Baisse Clause',
};

export const contractTypeLabel = (type: string): string =>
  LABELS[type] ?? type.replace(/([a-z])([A-Z])/g, '$1 $2').replace('_', ' ');
